export default __webpack_public_path__ + "static/media/avatar-default.2bca3eaa.png";